<template>
    <div class="mr-3">
        <button
            type="button"
            :class="['btn btnclass smallerfontsize', isProductAdvertiserAgencySelected ? 'selected' : '']"
            @click="form.productAdvertiserAgency.showProductAdvertiserAgencyModal = true"
        >
            Agency / Advertiser / Product
        </button>
        <b-modal
            v-model="form.productAdvertiserAgency.showProductAdvertiserAgencyModal"
            title="Select Agency / Advertiser / Product"
            :no-close-on-backdrop="true"
            @ok="saveProductAdvertiserAgency"
            @show="showModal"
            @hide="onHidden"
        >
            <div>
                <label>Agency</label>
                <div class="input-group mb-3">
                    <v-select v-model="selectedBuyingAgency" class="vueSelect" :options="form.buyingAgencies.selectlistitems" />
                </div>

                <div class="input-group mb-3">
                    <label>Advertiser</label>
                    <div class="input-group">
                        <v-select v-model="selectedAdvertiser" class="vueSelect" :options="form.advertisers.selectlistitems" />
                    </div>
                </div>
                <div class="input-group">
                    <label>Product</label>
                    <div class="input-group mb-3">
                        <v-select v-model="selectedProduct" class="vueSelect" :options="form.products.selectlistitems" />
                    </div>
                </div>
            </div>
            <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm" variant="primary" @click="ok()">
                    Save
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import "vue-select/dist/vue-select.css"
import vSelect from "vue-select"
import * as Mutations from "@/store/modules/ads/mutation-types"

export default {
    name: "ProductAdvertiserAgencyModal",
    components: {
        vSelect,
    },
    props: {
        form: Object,
    },
    data() {
        return {
            selectedBuyingAgency: "",
            selectedAdvertiser: "",
            selectedProduct: "",
        }
    },
    computed: {
        isProductAdvertiserAgencySelected() {
            let isProductAdvertiserAgencySelected = false
            let query = this.$store.getters.getAdsQuery
            if (query.advertisers || query.buyingAgencies || query.products) isProductAdvertiserAgencySelected = true
            return isProductAdvertiserAgencySelected
        },
    },
    methods: {
        onKeyUp(event) {
            if (event.key === "Enter" && this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal) {
                this.saveProductAdvertiserAgency()
                this.form.productAdvertiserAgency.showProductAdvertiserAgencyModal = false
            }
        },
        onHidden() {
            document.removeEventListener("keyup", this.onKeyUp)
        },
        setProductAdvertiserAgency() {
            let query = this.$store.getters.getAdsQuery
            this.selectedAdvertiser = query.advertisers ? query.advertisers : null
            this.selectedBuyingAgency = query.buyingAgencies ? query.buyingAgencies : null
            this.selectedProduct = query.products ? query.products : null
        },
        saveProductAdvertiserAgency() {
            const query = {
                ...this.$store.getters.getAdsQuery,
                advertisers: this.selectedAdvertiser,
                buyingAgencies: this.selectedBuyingAgency,
                products: this.selectedProduct,
            }
            this.$store.commit(Mutations.setAdsQuery, query)
        },
        showModal() {
            this.setProductAdvertiserAgency()
            document.addEventListener("keyup", this.onKeyUp)
        },
    },
}
</script>

<style scoped>
.vueSelect {
    width: 100%;
    font-size: 0.875rem;
}
</style>
